import {ListFilterTrigger} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TrustAccountFilterMenu} from './TrustAccountFilterMenu';
import {countActiveFilters} from '../../utils/filter.utils';

import type {TrustAccountFilterState} from '../../utils/filter.utils';
import type {FC} from 'react';

/** `dateLabel` renames the date section when a list filters on a date other than creation. */
export interface TrustAccountFilterProps {
  filter: TrustAccountFilterState;
  onChange: (filter: TrustAccountFilterState) => void;
  disabled?: boolean;
  dateLabel?: string;
}

export const TrustAccountFilter: FC<TrustAccountFilterProps> = ({
  filter,
  onChange,
  disabled = false,
  dateLabel
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ListFilterTrigger
      buttonLabel={t('filter.button')}
      activeCount={countActiveFilters(filter)}
      disabled={disabled}
    >
      <TrustAccountFilterMenu filter={filter} onChange={onChange} dateLabel={dateLabel} />
    </ListFilterTrigger>
  );
};
